import { getGemHost } from '@vkplay/shared';

const appendHeader = () => {
  let currentLang;

  window.EVA.init('shell', {
    simplified: true,
    footerSelector: '#shell-footer',
    onGetUser: (user) => {
      const lang = user.locale;

      if (currentLang === lang) {
        return false;
      }

      window.dispatchEvent(new CustomEvent('getLang', { detail: lang }));

      currentLang = lang;
    },
    showVPNSnack: true,
  });
};

(env => {
  appendHeader();
})(process.env.NODE_ENV);
